import {
  base_colorHighlight,
  cta_buttonPrimaryBackground,
  neutral600,
  purple200,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_size_4xl,
  font_size_lg,
  font_size_md,
  font_size_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  .HeadingText {
    // TODO: Pair font-size and line-heights
    font-size: ${font_size_4xl};
    line-height: 36px;
    text-align: center;
  }

  .SubText {
    // TODO: Pair font-size and line-heights
    font-size: ${font_size_lg};
    line-height: 20px;
    // TODO: Figma mismatch between variables and visuals check value
    color: ${text_colorTextSecondary};
    text-align: center;
    max-width: 666px;
  }

  .LabelToggle-section {
    padding-top: ${spacing(6)};
    padding-bottom: ${spacing(10)};
  }

  .PricingCards-container {
    width: 100%;
  }

  .PricingCard-component {
    // check this
    max-width: 388px;
  }

  .PricingCard-component-pro {
    position: relative;
  }

  .PricingCard-pro-promoText {
    position: absolute;
    top: -10px;
  }

  .PricingCard-name {
    display: flex;
    flex-direction: column;
    min-height: 72px;
}

  .PricingCard-name-topText {
    color: ${neutral600};
    font-size: ${font_size_md};
    line-height: 18px;
  }

  .PricingCard-Avatar-enterprise {
    flex-shrink: 0;
  }

  .PricingCard-name-planTitle {
    // TODO: Find this size in design system with Kimi
    font-size: 28px;
    font-weight: bold;
    line-height: 36px;
  }

  .PricingCard-strikeout {
    color: ${text_colorTextSecondary};
    text-decoration: line-through;
    font-weight: bold;
    line-height: normal;
    font-size: 20px;
  }

  .PricingCard-price-details {
    display: flex;
    flex-direction: column;
    min-height: 36px;
  }

  .PricingCard-per-bigPrice {
    font-size: 40px;
    line-height: 48px;
  }

  .PricingCard-per-superScript {
    font-size: ${font_size_md};
    line-height: 18px;
    vertical-align: top;
  }

  .PricingCard-per-userValue {
    color: ${text_colorTextPrimary};
    line-height: 20px;
    font-size: ${font_size_lg};
  }

  .PricingCard-price-details-text {
    color: ${text_colorTextSecondary};
    font-size: ${font_size_sm};
    line-height: 16px;
  }

  .Button-cta {
    width: 100%;
  }

  .PricingCard-getStarted-heading {
    font-size: ${font_size_lg};
    line-height: 20px;
    font-weight: bold;
  }

  .PricingCard-AI-Powered {
    background-color: ${purple200};
    padding: ${spacing(2)};
    border-radius: 8px;
  }

  .PricingCard-AI-Powered-text {
    color: ${base_colorHighlight};
    font-weight: bold;
    font-size: ${font_size_lg};
    line-height: 20px;
  }

  .PricingCard-checklist-item-text {
    font-size: ${font_size_lg};
    line-height: 20px;
  }
  // PLACEHOLDER
  .LinkText {
    color: ${cta_buttonPrimaryBackground};
    font-size: ${font_size_sm};
    line-height: 18px;
    font-weight: bold;
  }
`
